// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__yrDFv","hr":"Footer_hr__S8PKG","createdBy":"Footer_createdBy__Xbo-+","twitter":"Footer_twitter__meKM-"};